export const GET_NAME_LIST_REQUEST = 'GET_NAME_LIST_REQUEST';
export const GET_NAME_LIST_SUCCESS = 'GET_NAME_LIST_SUCCESS';
export const GET_NAME_LIST_FAILED = 'GET_NAME_LIST_FAILED';

export const GET_NAME_VALUE_REQUEST = 'GET_NAME_VALUE_REQUEST';
export const GET_NAME_VALUE_SUCCESS = 'GET_NAME_VALUE_SUCCESS';
export const GET_NAME_VALUE_FAILED = 'GET_NAME_VALUE_FAILED';

export const GET_SCRIPT_REQUEST = 'GET_SCRIPT_REQUEST';
export const GET_SCRIPT_SUCCESS = 'GET_SCRIPT_SUCCESS';
export const GET_SCRIPT_FAILED = 'GET_SCRIPT_FAILED';

export const ADD_NEW_SCRIPT_REQUEST = 'ADD_NEW_SCRIPT_REQUEST';
export const ADD_NEW_SCRIPT_SUCCESS = 'ADD_NEW_SCRIPT_SUCCESS';
export const ADD_NEW_SCRIPT_FAILED = 'ADD_NEW_SCRIPT_FAILED';

export const EDIT_SCRIPT_DATA_REQUEST = 'EDIT_SCRIPT_DATA_REQUEST';
export const EDIT_SCRIPT_DATA_SUCCESS = 'EDIT_SCRIPT_DATA_SUCCESS';
export const EDIT_SCRIPT_DATA_FAILED = 'EDIT_SCRIPT_DATA_FAILED';

export const DELETE_SCRIPT_DATA_REQUEST = 'DELETE_SCRIPT_DATA_REQUEST';
export const DELETE_SCRIPT_DATA_SUCCESS = 'DELETE_SCRIPT_DATA_SUCCESS';
export const DELETE_SCRIPT_DATA_FAILED = 'DELETE_SCRIPT_DATA_FAILED';

export const CLEAR_RESPONSE = 'CLEAR_RESPONSE';

export const GetNameListAction = (type: String) => {
    return { type: GET_NAME_LIST_REQUEST, payload: type };
};

export const GetNameValueAction = (name: String) => {
    return { type: GET_NAME_VALUE_REQUEST, payload: name };
};

export const GetScriptAction = (value: String) => {
    return { type: GET_SCRIPT_REQUEST, payload: value };
};

export const AddNewScriptAction = (data: any) => {
    return { type: ADD_NEW_SCRIPT_REQUEST, payload: data };
};

export const EditScriptDataAction = (data: any) => {
    return { type: EDIT_SCRIPT_DATA_REQUEST, payload: data };
};

export const DeleteScriptDataAction = (data: any) => {
    return { type: DELETE_SCRIPT_DATA_REQUEST, payload: data };
};

export const ClearResponseAction = () => {
    return { type: CLEAR_RESPONSE };
};